import { PAD_ALTERATION_TYPE } from 'app/config/pad';

const { CREATION, SUSPENSION } = PAD_ALTERATION_TYPE;

const STATUS = {
  ACTIVE: 1,
  INACTIVE: 0
};

export default class BuildPadVisit {
  constructor(padVisit) {
    this._padVisit = padVisit;
  }

  addPadVisitCode = function (code) {
    this._padVisit.code = code;

    return this;
  };

  addPadVisitType = function (padVisitType) {
    this._padVisit.padVisitType = padVisitType;

    return this;
  };

  addPadVisitAlterId = function (padVisitAlterId) {
    this._padVisit.padVisitAlterId = padVisitAlterId;

    return this;
  };

  addStatus = function (status) {
    this._padVisit.status = status;

    return this;
  };

  setUpdateStatus = function () {
    this._padVisit.itHasBeenUpdated = true;

    return this;
  };

  suspendPadVisit = function (id) {
    this.addPadVisitType(SUSPENSION);
    this.addPadVisitAlterId(id);
    this.addStatus(STATUS.INACTIVE);

    return this;
  };

  unsuspendPadVisit = function () {
    this.addPadVisitType(CREATION);
    this.addPadVisitAlterId(null);
    this.addStatus(STATUS.ACTIVE);

    return this;
  };

  // addPadCardType = function (padCardType) {
  //   this._padVisit.padCardType = padCardType;

  //   return this;
  // };

  getPadVisit = function () {
    return this._padVisit;
  };

  cleanPadVisit = function (callback) {
    const { frequency, visitationType, profession, responsible } = this._padVisit;

    this._padVisit.frequency = callback(frequency, ['id', 'name']);
    this._padVisit.visitationType = callback(visitationType, ['id', 'name']);
    this._padVisit.profession = callback(profession, ['id', 'name']);
    this._padVisit.responsible = callback(responsible, ['id', 'name']);

    // delete this._padVisit.id;  // keep id because it's a reference to suspend
    delete this._padVisit.code;
    delete this._padVisit.padVisitType;
    delete this._padVisit.padVisitAlterId;

    delete this._padVisit.pad;
    delete this._padVisit.padId;

    delete this._padVisit.prescription;
    delete this._padVisit.padVisitAlter;
    delete this._padVisit.preferedShift;
    delete this._padVisit.preferedWeekDays;

    delete this._padVisit.created;
    delete this._padVisit.updated;

    this._padVisit.padVisitAlterId = null;

    return this;
  };
}
